"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useIsComponentMounted;

var _react = require("react");

function useIsComponentMounted() {
  var isMounted = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    isMounted.current = true;
    return function () {
      return isMounted.current = false;
    };
  }, []);
  return isMounted;
}

;